import { fetcher } from '@commenda/utils';

import { TActivateBillingParams } from './types';

export const activateBilling = async (params: TActivateBillingParams) => {
  const { quoteId, ...body } = params;
  const response = await fetcher(
    `commenda-billing/quotes/${quoteId}/activate-billing`,
    {
      method: 'POST',
      body,
    }
  );

  return response;
};
